import CustomDialog from 'Components/CustomDialog/CustomDialog'
import { LinearProgress } from '@mui/material'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import type { FC } from 'react'
import { t } from 'ttag'

const DeleteDialog: FC<{
  open: boolean
  handleClose: () => void
  handleSubmit: () => void
  loading: boolean
  title: string
  children: React.ReactNode
}> = ({ open, handleClose, handleSubmit, loading, title, children }) => {
  const theme = useTheme()

  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <DialogTitle id="dialog-title">{title}</DialogTitle>
      <DialogContent>
        {loading ? (
          <LinearProgress />
        ) : (
          <DialogContentText>
            <Typography component="span" color="text.primary">
              {children}
            </Typography>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ color: theme.palette.text.primary }}
          onClick={handleClose}
        >{t`Cancel`}</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="error"
          disabled={loading}
          autoFocus
        >
          {t`Delete`}
        </Button>
      </DialogActions>
    </CustomDialog>
  )
}

export default DeleteDialog
